import { c as _c } from "react/compiler-runtime";
import { classNames } from '@/util/utils';
import { styleBlockLarge } from '../styles';
import type React from 'react';
import styles from './error.module.css';
interface ErrorProps {
  className?: string;
  children: React.ReactNode;
}
export default function Error(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.error, styleBlockLarge);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}